import { FScoreMetric } from 'app/model/redshift/f-score-metric';
import { RestfulApiService } from 'app/services/restful-api.service';

class FScoreReportService extends RestfulApiService<FScoreMetric> {
    protected getFormName(): string {
        return 'impact_report';
    }

    protected getPath(): string {
        return 'qa/f-score';
    }
}

export const fScoreReportService = new FScoreReportService();
